//add pictures to assets folder
//import them here

import Project1 from "../../assets/project1.png"
import Project2 from "../../assets/project2.png"
import Project3 from "../../assets/project3.png"
import Project4 from "../../assets/project4.png"



const Menu = [
    {
        id: 1,
        image: Project1,
        title: "Crypto Scanner App",
        category: "React",
        url: "https://krypto-labs.herokuapp.com/",
    },
    {
        id: 2,
        image: Project2,
        title: "Crypto CRUD App",
        category: "Ruby",
        url: "https://auction-app-heroku.herokuapp.com/",
    },
    {
        id: 3,
        image: Project3,
        title: "In-Game Item Auction App",
        category: "JavaScript",
        url: "https://ruby-crypto-scanner.herokuapp.com/",
    },
    {
        id: 4,
        image: Project4,
        title: "Boba Tea Website",
        category: "React",
        url: "http://the-boba-store.surge.sh/",
    },

]

export default Menu